import { render, staticRenderFns } from "./app-header.vue?vue&type=template&id=b7ce2a1e"
import script from "./app-header.vue?vue&type=script&setup=true&lang=ts"
export * from "./app-header.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports